import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  // TODO: The tenants query returns a response of type { items: Tenant[],
  // nextCursor?: string }. To align with the expected return type of the list
  // method (Tenant[]), we map the response here.
  // Pagination by cursor should be implemented
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(() =>
    gql.queries.tenants.execute().pipe(rxjs.map(({ items }) => items)),
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (_, input) =>
    gql.mutations.createTenant.executor({
      input: gql.inputs.tenant.INPUT.getGqlFrom(input),
    })

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (_, { id, updates }) =>
    gql.mutations.updateTenant.executor({
      updateTenantId: id,
      updates: gql.inputs.tenant.UPDATES.getGqlFrom(updates),
    })

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (_, id) =>
    gql.mutations.deleteTenant.executor({
      deleteTenantId: id,
    })

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', {
        isSortable: true,
        name: 'Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('alias', {
        isSortable: true,
        name: 'Alias',
      }),
      ec.models.Attribute.fromKey<TypeParams>('code', {
        isSortable: true,
        name: 'Code',
      }),
    ])
}
